// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("/public/how-bg.png", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.waitlist-modal .modal-dialog {
  max-width: 1000px;
}

.waitlist-modal .modal-content {
  border-radius: 20px;
  border: none;
  box-shadow: 0 20px 40px rgba(0, 0, 0, 0.15);
  background: white;
  position: relative;
  overflow: hidden;
}

/* Dotted background pattern */
.waitlist-modal .modal-content::before {
  content: '';
  position: absolute;
  top: -50px;
  left: -50px;
  right: -50px;
  bottom: -50px;
  background-image: radial-gradient(circle, #e8f0ff 2px, transparent 2px);
  background-size: 20px 20px;
  opacity: 0.6;
  z-index: -1;
}

.waitlist-modal .modal-header {
  border-bottom: none;
  padding: 1.5rem 1.5rem 0;
  position: relative;
  z-index: 1;
}

.waitlist-modal .modal-title {
  display: flex;
  justify-content: center;
  align-items: center;
}

.maia-logo {
  height: 40px;
  width: auto;
}

.waitlist-modal .modal-body {
  padding: 0 2rem 2rem;
  position: relative;
  z-index: 1;
}

.waitlist-content {
  text-align: center;
  padding: 1rem 0;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
  background-size: contain;
  background-position: center;
  background-repeat: no-repeat;
  height: 100%;
  width: 100%;
}

.waitlist-title {
  font-family: 'Gilroy', sans-serif;
  font-weight: 700;
  font-size: 40px;
  color: #282c34;
  margin-bottom: 1rem;
  line-height: 1.2;
  text-align: center;
}

.waitlist-description {
  font-family: 'Gilroy', sans-serif;
  color: #666;
  margin-bottom: 1.5rem;
  font-size: 20px;
  line-height: 1.5;
  text-align: center;
  font-weight: 400;
}

.waitlist-subtitle {
  font-family: 'Gilroy', sans-serif;
  color: #666;
  margin-bottom: 1rem;
  font-size: 20px;
  line-height: 1.5;
  text-align: center;
  font-weight: 400;
}

.go2461894273{
  padding: 0px 20px !important;
}

.go83767167{
  padding: 0px 20px !important;
}

.go2461894273:hover{
  border: 3px solid #fff !important;
}

.go3176171171{
  color: #fff !important;
}

.klaviyo-form-Xkrk6z {
  width: 150% !important;
}

.klaviyo-form-U4jbv2{
  width: 150% !important;
}

.klaviyo-form-Weg8cf{
  width: 100% !important;
}

.waitlist-subtitle strong {
  color: #282c34;
  font-weight: 600;
}

.waitlist-form {
  display: flex;
  flex-direction: column;
  gap: 1rem;
  align-items: center;
}

.form-group {
  width: 100%;
  max-width: 350px;
}

.email-input {
  border-radius: 12px;
  border: 2px solid #e9ecef;
  padding: 1rem 1.25rem;
  font-family: 'Gilroy', sans-serif;
  transition: border-color 0.3s ease, box-shadow 0.3s ease;
  font-size: 1rem;
  background-color: #f8f9fa;
  color: #495057;
  width: 100%;
}

.email-input::placeholder {
  color: #adb5bd;
}

.email-input:focus {
  border-color: #2F80ED;
  box-shadow: 0 0 0 0.2rem rgba(47, 128, 237, 0.15);
  background-color: white;
  outline: none;
}

.waitlist-submit-btn {
  background: #2F80ED;
  border: none;
  border-radius: 100px;
  padding: 1rem 2rem;
  font-family: 'Gilroy', sans-serif;
  font-weight: 600;
  font-size: 1rem;
  color: white;
  transition: all 0.2s ease;
  width: 100%;
  max-width: 350px;
}

.waitlist-submit-btn:hover {
  background: #1a6fd8;
  transform: translateY(-1px);
  box-shadow: 0 4px 12px rgba(47, 128, 237, 0.3);
}

.waitlist-submit-btn:active {
  transform: translateY(0);
}

.waitlist-modal .btn-close {
  font-size: 1.2rem;
  color: #282c34;
  opacity: 0.7;
  transition: opacity 0.2s ease;
}

.waitlist-modal .btn-close:hover {
  opacity: 1;
}

@media (max-width: 576px) {
  .waitlist-modal .modal-dialog {
    margin: 1rem;
    max-width: none;
  }
  
  .waitlist-modal .modal-header,
  .waitlist-modal .modal-body {
    padding-left: 1.5rem;
    padding-right: 1.5rem;
  }

  .waitlist-modal .modal-body {
    padding-bottom: 1.5rem;
  }
  
  .waitlist-title {
    font-size: 1.75rem;
  }
  
  .waitlist-description,
  .waitlist-subtitle {
    font-size: 0.9rem;
  }
  
  .email-input {
    padding: 0.875rem 1rem;
    font-size: 0.9rem;
  }
  
  .waitlist-submit-btn {
    padding: 0.875rem 1.5rem;
    font-size: 0.9rem;
  }
} `, "",{"version":3,"sources":["webpack://./src/components/WaitlistModal/WaitlistModal.css"],"names":[],"mappings":"AAAA;EACE,iBAAiB;AACnB;;AAEA;EACE,mBAAmB;EACnB,YAAY;EACZ,2CAA2C;EAC3C,iBAAiB;EACjB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA,8BAA8B;AAC9B;EACE,WAAW;EACX,kBAAkB;EAClB,UAAU;EACV,WAAW;EACX,YAAY;EACZ,aAAa;EACb,uEAAuE;EACvE,0BAA0B;EAC1B,YAAY;EACZ,WAAW;AACb;;AAEA;EACE,mBAAmB;EACnB,wBAAwB;EACxB,kBAAkB;EAClB,UAAU;AACZ;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,YAAY;EACZ,WAAW;AACb;;AAEA;EACE,oBAAoB;EACpB,kBAAkB;EAClB,UAAU;AACZ;;AAEA;EACE,kBAAkB;EAClB,eAAe;EACf,yDAA2C;EAC3C,wBAAwB;EACxB,2BAA2B;EAC3B,4BAA4B;EAC5B,YAAY;EACZ,WAAW;AACb;;AAEA;EACE,iCAAiC;EACjC,gBAAgB;EAChB,eAAe;EACf,cAAc;EACd,mBAAmB;EACnB,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,iCAAiC;EACjC,WAAW;EACX,qBAAqB;EACrB,eAAe;EACf,gBAAgB;EAChB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,iCAAiC;EACjC,WAAW;EACX,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;EACE,iCAAiC;AACnC;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,yBAAyB;EACzB,qBAAqB;EACrB,iCAAiC;EACjC,wDAAwD;EACxD,eAAe;EACf,yBAAyB;EACzB,cAAc;EACd,WAAW;AACb;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,qBAAqB;EACrB,iDAAiD;EACjD,uBAAuB;EACvB,aAAa;AACf;;AAEA;EACE,mBAAmB;EACnB,YAAY;EACZ,oBAAoB;EACpB,kBAAkB;EAClB,iCAAiC;EACjC,gBAAgB;EAChB,eAAe;EACf,YAAY;EACZ,yBAAyB;EACzB,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,2BAA2B;EAC3B,8CAA8C;AAChD;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,iBAAiB;EACjB,cAAc;EACd,YAAY;EACZ,6BAA6B;AAC/B;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE;IACE,YAAY;IACZ,eAAe;EACjB;;EAEA;;IAEE,oBAAoB;IACpB,qBAAqB;EACvB;;EAEA;IACE,sBAAsB;EACxB;;EAEA;IACE,kBAAkB;EACpB;;EAEA;;IAEE,iBAAiB;EACnB;;EAEA;IACE,sBAAsB;IACtB,iBAAiB;EACnB;;EAEA;IACE,wBAAwB;IACxB,iBAAiB;EACnB;AACF","sourcesContent":[".waitlist-modal .modal-dialog {\n  max-width: 1000px;\n}\n\n.waitlist-modal .modal-content {\n  border-radius: 20px;\n  border: none;\n  box-shadow: 0 20px 40px rgba(0, 0, 0, 0.15);\n  background: white;\n  position: relative;\n  overflow: hidden;\n}\n\n/* Dotted background pattern */\n.waitlist-modal .modal-content::before {\n  content: '';\n  position: absolute;\n  top: -50px;\n  left: -50px;\n  right: -50px;\n  bottom: -50px;\n  background-image: radial-gradient(circle, #e8f0ff 2px, transparent 2px);\n  background-size: 20px 20px;\n  opacity: 0.6;\n  z-index: -1;\n}\n\n.waitlist-modal .modal-header {\n  border-bottom: none;\n  padding: 1.5rem 1.5rem 0;\n  position: relative;\n  z-index: 1;\n}\n\n.waitlist-modal .modal-title {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n}\n\n.maia-logo {\n  height: 40px;\n  width: auto;\n}\n\n.waitlist-modal .modal-body {\n  padding: 0 2rem 2rem;\n  position: relative;\n  z-index: 1;\n}\n\n.waitlist-content {\n  text-align: center;\n  padding: 1rem 0;\n  background-image: url('/public/how-bg.png');\n  background-size: contain;\n  background-position: center;\n  background-repeat: no-repeat;\n  height: 100%;\n  width: 100%;\n}\n\n.waitlist-title {\n  font-family: 'Gilroy', sans-serif;\n  font-weight: 700;\n  font-size: 40px;\n  color: #282c34;\n  margin-bottom: 1rem;\n  line-height: 1.2;\n  text-align: center;\n}\n\n.waitlist-description {\n  font-family: 'Gilroy', sans-serif;\n  color: #666;\n  margin-bottom: 1.5rem;\n  font-size: 20px;\n  line-height: 1.5;\n  text-align: center;\n  font-weight: 400;\n}\n\n.waitlist-subtitle {\n  font-family: 'Gilroy', sans-serif;\n  color: #666;\n  margin-bottom: 1rem;\n  font-size: 20px;\n  line-height: 1.5;\n  text-align: center;\n  font-weight: 400;\n}\n\n.go2461894273{\n  padding: 0px 20px !important;\n}\n\n.go83767167{\n  padding: 0px 20px !important;\n}\n\n.go2461894273:hover{\n  border: 3px solid #fff !important;\n}\n\n.go3176171171{\n  color: #fff !important;\n}\n\n.klaviyo-form-Xkrk6z {\n  width: 150% !important;\n}\n\n.klaviyo-form-U4jbv2{\n  width: 150% !important;\n}\n\n.klaviyo-form-Weg8cf{\n  width: 100% !important;\n}\n\n.waitlist-subtitle strong {\n  color: #282c34;\n  font-weight: 600;\n}\n\n.waitlist-form {\n  display: flex;\n  flex-direction: column;\n  gap: 1rem;\n  align-items: center;\n}\n\n.form-group {\n  width: 100%;\n  max-width: 350px;\n}\n\n.email-input {\n  border-radius: 12px;\n  border: 2px solid #e9ecef;\n  padding: 1rem 1.25rem;\n  font-family: 'Gilroy', sans-serif;\n  transition: border-color 0.3s ease, box-shadow 0.3s ease;\n  font-size: 1rem;\n  background-color: #f8f9fa;\n  color: #495057;\n  width: 100%;\n}\n\n.email-input::placeholder {\n  color: #adb5bd;\n}\n\n.email-input:focus {\n  border-color: #2F80ED;\n  box-shadow: 0 0 0 0.2rem rgba(47, 128, 237, 0.15);\n  background-color: white;\n  outline: none;\n}\n\n.waitlist-submit-btn {\n  background: #2F80ED;\n  border: none;\n  border-radius: 100px;\n  padding: 1rem 2rem;\n  font-family: 'Gilroy', sans-serif;\n  font-weight: 600;\n  font-size: 1rem;\n  color: white;\n  transition: all 0.2s ease;\n  width: 100%;\n  max-width: 350px;\n}\n\n.waitlist-submit-btn:hover {\n  background: #1a6fd8;\n  transform: translateY(-1px);\n  box-shadow: 0 4px 12px rgba(47, 128, 237, 0.3);\n}\n\n.waitlist-submit-btn:active {\n  transform: translateY(0);\n}\n\n.waitlist-modal .btn-close {\n  font-size: 1.2rem;\n  color: #282c34;\n  opacity: 0.7;\n  transition: opacity 0.2s ease;\n}\n\n.waitlist-modal .btn-close:hover {\n  opacity: 1;\n}\n\n@media (max-width: 576px) {\n  .waitlist-modal .modal-dialog {\n    margin: 1rem;\n    max-width: none;\n  }\n  \n  .waitlist-modal .modal-header,\n  .waitlist-modal .modal-body {\n    padding-left: 1.5rem;\n    padding-right: 1.5rem;\n  }\n\n  .waitlist-modal .modal-body {\n    padding-bottom: 1.5rem;\n  }\n  \n  .waitlist-title {\n    font-size: 1.75rem;\n  }\n  \n  .waitlist-description,\n  .waitlist-subtitle {\n    font-size: 0.9rem;\n  }\n  \n  .email-input {\n    padding: 0.875rem 1rem;\n    font-size: 0.9rem;\n  }\n  \n  .waitlist-submit-btn {\n    padding: 0.875rem 1.5rem;\n    font-size: 0.9rem;\n  }\n} "],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
